module.exports = __webpack_public_path__ + "static/media/Decidueye_gaussian2.31721e51.png";